import { render, staticRenderFns } from "./PayrollRequestCompleted.vue?vue&type=template&id=4ceeb21a"
import script from "./PayrollRequestCompleted.vue?vue&type=script&lang=js"
export * from "./PayrollRequestCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports